/**
 * 分时图、K线图
 */
import React, { useEffect, useState } from "react"
import { formatBigNumber, formatBondSingleColor, formatCompareColor, formatNumToFixed, formatSingleColor, formatStockColor, formatTipsCompareColor, formatToSub, formatUniqueNumToFixed, formatUnit, toFix } from "../utils"
import "./index.less"
import { TimeTrade } from "./components/time_trade"
import { store as UKStore } from "../../page/uk/store"
import { store as CHStore } from "../../page/ch/store"
import { store as USStore } from "../../page/us/store"
import { store as ForexStore } from "../../page/forex/store"
import { store as GlobalIndexStore } from "../../page/globalindex/store"
import { store as AStore } from "../../page/a/store"
import { store as BKStore } from "../../page/bk/store"
import { store as ZSStore } from "../../page/zs/store"
import { store as CNYStore } from "../../page/cnyrate/store"
import { store as BondStore } from "../../page/bond/store"
import { store as HKStore } from "../../page/hk/store"
import { store as QHStore } from "../../page/qihuo/store"
import { store as GlobalFutureStore } from "../../page/globalfuture/store"
import { store as GZQHStore } from "../../page/gzqh/store"
import { store as OptionStore } from "../../page/option/store"
import { store as BStore } from "../../page/b/store"
import { store as FundStore } from "../../page/fund/store"
import { store as TipsStore } from "../../page/tips/store"
import { store as DefaultStore } from "../../page/default/store"
import { quotedata } from "../quotedata"
import { Observer } from "mobx-react-lite"
import { quote_item_name, single_quote } from "../quotedata/index"
import { ChartType } from "../utils"
import { getStockSubType, PageBondType, PageType, StockSubType } from "../pagetype"
import hk_rule from "../../../modules/hk_rule"

let chart: any

// 分时图
export function TimeCharts(props: { quotedata: quotedata; charttype: ChartType; pagetype: PageType; stocksubtype: StockSubType; bondsubtype?: PageBondType; reverseColor?: boolean}) {
  let timer: any = null
  let fsStatus = 0

  // 绘制分时图
  const drawTimeChart = (stockCode: string) => {
    let nday = props.charttype == ChartType.分时 ? 1 : 5

    if (props.pagetype == PageType.沪深A股) {
      getTradeStatus(AStore.StockDetail)
    } else if (props.pagetype == PageType.英股) {
      getTradeStatus(UKStore.StockDetail)
    } else if (props.pagetype == PageType.瑞士GDR) {
      getTradeStatus(CHStore.StockDetail)
    } else if (props.pagetype == PageType.美股) {
      getTradeStatus(USStore.StockDetail)
    } else if (props.pagetype == PageType.外汇) {
      getTradeStatus(ForexStore.StockDetail)
    } else if (props.pagetype == PageType.全球指数) {
      getTradeStatus(GlobalIndexStore.StockDetail)
    } else if (props.pagetype == PageType.板块) {
      getTradeStatus(BKStore.StockDetail)
    } else if (props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.choice指数) {
      getTradeStatus(ZSStore.StockDetail)
    } else if (props.pagetype == PageType.人民币中间价) {
      getTradeStatus(ForexStore.StockDetail)
    } else if (props.pagetype == PageType.债券) {
      getTradeStatus(BondStore.StockDetail)
    } else if (props.pagetype == PageType.港股) {
      getTradeStatus(HKStore.StockDetail)
    } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.商品期货) {
      getTradeStatus(QHStore.StockDetail)
    } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.国际期货) {
      getTradeStatus(GlobalFutureStore.StockDetail)
    } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.金融期货) {
      getTradeStatus(GZQHStore.StockDetail)
    } else if (props.pagetype == PageType.期权) {
      getTradeStatus(OptionStore.StockDetail)
    } else if (props.pagetype == PageType.B股) {
      getTradeStatus(BStore.StockDetail)
    } else if (props.pagetype == PageType.场内基金) {
      getTradeStatus(FundStore.StockDetail)
    } else if (props.pagetype == PageType.全球债券) {
      getTradeStatus(TipsStore.StockDetail)
    } else if(props.pagetype == PageType.未知){
      getTradeStatus(DefaultStore.StockDetail)
    }

    if (window.mobilequotechart && stockCode) {
      try {
        chart = null
      } catch (error) {}
      chart = new window.mobilequotechart({
        id: "#chart1", // Canvas画布所在的父元素的ID
        code: stockCode, // 股票代码
        ut: "f057cbcbce2a86e2866ab8877db1d059", // 接口请求参数ut
        width: $("#chart1").width(), // Canvas画布的宽度，如果没传则继承父元素宽度
        height: $(".charts").height(), // Canvas画布的高度，如果没传则继承父元素高度
        ndays: nday, // 分时图时，所展示的分时天数，当 n 的值大于1时，盘前设置则无效
        iscr: fsStatus == 1 && props.pagetype == PageType.沪深A股 ? true : false, // 分时图是否展示盘前数据
        iscca: props.stocksubtype == StockSubType.创业板 || props.stocksubtype == StockSubType.科创板 ? true : false, // 分时图是否展示盘后数据
        cursor: true, // 是否使用交互功能
        simplemode: true, // 是否开启简单配置模式
        simpletype: "time", // 简单配置模式图的类型 time、kline分别对应分时图和K线图
        reverseColor: ((props.stocksubtype == StockSubType.中国关键期国债 || props.stocksubtype == StockSubType.美国关键期国债 || props.stocksubtype == StockSubType.全球关键期国债) && props.reverseColor) ? true : false,
        cursorCallback: function (data: any, index: number, state: any) {
          // data 是数据，index是当前数据的位置，state 是滑动状态
          if (props.pagetype == PageType.沪深A股) {
            AStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.英股) {
            UKStore.setChartType(ChartType.分时)
          } else if (props.pagetype == PageType.瑞士GDR) {
            CHStore.setChartType(ChartType.分时)
          } else if (props.pagetype == PageType.美股) {
            USStore.setChartType(ChartType.分时)
          } else if (props.pagetype == PageType.外汇) {
            ForexStore.setChartType(ChartType.分时)
          } else if (props.pagetype == PageType.全球指数) {
            GlobalIndexStore.setChartType(ChartType.分时)
          } else if (props.pagetype == PageType.板块) {
            BKStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.choice指数) {
            ZSStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.人民币中间价) {
            CNYStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.债券) {
            BondStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.港股) {
            HKStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.商品期货) {
            QHStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.国际期货) {
            GlobalFutureStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.金融期货) {
            GZQHStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.期权) {
            OptionStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.B股) {
            BStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.场内基金) {
            FundStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.全球债券) {
            TipsStore.setChartType(props.charttype)
          } else if (props.pagetype == PageType.未知) {
            DefaultStore.setChartType(props.charttype)
          }
          showFSData(data, index, state)
        },
      })
      chart.init()
    }
  }

  const showFSData = (data: any, index: number, state: any) => {
    if (state == "start" || state == "move") {
      let FSData = {}
      const newPrice = data.trends[index].price
      const zdf = toFix(((data.trends[index].price - data.prePrice) / data.prePrice) * 100, 2) + "%"
      const zde = toFix(data.trends[index].price - data.prePrice, data.decimal)
      const _color = formatCompareColor(data.trends[index].price,data.prePrice)
      FSData = {
        ...data,
        newPrice,
        zdf,
        zde,
        _color,
      }
      // 若为沪深A股
      if (props.pagetype == PageType.沪深A股) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](AStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](AStore.StockDetail).source) * 100, 2) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
        }
        AStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.英股) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](UKStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](UKStore.StockDetail).source) * 100, 3) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 0),
          zongzhi: single_quote[quote_item_name.总市值](UKStore.StockDetail).element,
        }
        UKStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.瑞士GDR) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](CHStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](CHStore.StockDetail).source) * 100, 3) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 0),
          zongzhi: single_quote[quote_item_name.总市值](CHStore.StockDetail).element,
        }
        CHStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.美股) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](USStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](USStore.StockDetail).source) * 100, 3) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
        }
        USStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.外汇) {
        ForexStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.全球指数) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](GlobalIndexStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](GlobalIndexStore.StockDetail).source) * 100, 2) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
          amplitude: formatUnit(formatNumToFixed(GlobalIndexStore.StockDetail.f171, GlobalIndexStore.StockDetail.f152), "%"),
        }
        GlobalIndexStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.板块) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](BKStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](BKStore.StockDetail).source) * 100, 2) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
        }
        BKStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.choice指数) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](ZSStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](ZSStore.StockDetail).source) * 100, 2) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
          zongzhi: single_quote[quote_item_name.总市值](AStore.StockDetail).element,
          liuzhi: single_quote[quote_item_name.流通市值](AStore.StockDetail).element,
          shiying: single_quote[quote_item_name.市盈率](AStore.StockDetail).element,
        }
        ZSStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.人民币中间价) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](CNYStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](CNYStore.StockDetail).source) * 100, 2) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
          amplitude: formatUnit(formatNumToFixed(CNYStore.StockDetail.f171, CNYStore.StockDetail.f152), "%"),
        }
        CNYStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.债券) {
        if (props.bondsubtype == PageBondType.上证可转债 || props.bondsubtype == PageBondType.深证可转债) {
          FSData = {
            ...FSData,
            huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](BondStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](BondStore.StockDetail).source) * 100, 2) + "%",
            zongshou: formatBigNumber(data.trends[index].volume, 2),
            liangbi: formatNumToFixed(BondStore.StockDetail.f50, BondStore.StockDetail.f152),
            amount: data.trends[index].amount,
            volume: data.trends[index].volume,
          }
          BondStore.setChartMouseMoveData(FSData)
        } else if (props.bondsubtype == PageBondType.上证质押式回购 || props.bondsubtype == PageBondType.深证质押式回购 || props.bondsubtype == PageBondType.上证现券 || props.bondsubtype == PageBondType.深证现券 || props.bondsubtype == PageBondType.北证债券) {
          FSData = {
            ...FSData,
            newPrice: data.trends[index].price,
            _color: formatCompareColor(data.trends[index].price, data.prePrice),
            zdf: toFix((data.trends[index].price - data.prePrice) / data.prePrice * 100, 2, "%"),
            zde: toFix(data.trends[index].price - data.prePrice, data.decimal),
            average_price: formatBigNumber(data.trends[index].average_price,3),
            amount: data.trends[index].amount,
            volume: data.trends[index].volume,
          }
          BondStore.setChartMouseMoveData(FSData)
        }
      } else if (props.pagetype == PageType.港股) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](HKStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](HKStore.StockDetail).source) * 100, 2) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
        }
        HKStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.期货) {
        if (props.stocksubtype == StockSubType.商品期货) {
          FSData = {
            ...FSData,
            zongshou: formatBigNumber(data.trends[index].volume, 2),
            chicang: formatBigNumber(single_quote[quote_item_name.持仓](QHStore.StockDetail).source, 2),
            rizeng: formatToSub(single_quote[quote_item_name.持仓](QHStore.StockDetail).source, QHStore.StockDetail.f132),
            jiesuan: formatNumToFixed(single_quote[quote_item_name.结算](QHStore.StockDetail).source, QHStore.StockDetail.f59),
            zuojie: formatNumToFixed(single_quote[quote_item_name.昨结](QHStore.StockDetail).source, QHStore.StockDetail.f59),
          }
          QHStore.setChartMouseMoveData(FSData)
        } else if (props.stocksubtype == StockSubType.国际期货) {
          FSData = {
            ...FSData,
            zongshou: formatBigNumber(data.trends[index].volume, 2),
            chicang: formatBigNumber(single_quote[quote_item_name.持仓](GlobalFutureStore.StockDetail).source, 2),
            rizeng: formatToSub(single_quote[quote_item_name.持仓](GlobalFutureStore.StockDetail).source, GlobalFutureStore.StockDetail.f132),
            jiesuan: formatNumToFixed(single_quote[quote_item_name.结算](GlobalFutureStore.StockDetail).source, GlobalFutureStore.StockDetail.f59),
            zuojie: formatNumToFixed(single_quote[quote_item_name.昨结](GlobalFutureStore.StockDetail).source, GlobalFutureStore.StockDetail.f59),
          }
          GlobalFutureStore.setChartMouseMoveData(FSData)
        } else if (props.stocksubtype == StockSubType.金融期货) {
          FSData = {
            ...FSData,
            zongshou: formatBigNumber(data.trends[index].volume, 2),
            chicang: formatBigNumber(single_quote[quote_item_name.持仓](GZQHStore.StockDetail).source, 2),
            rizeng: formatToSub(single_quote[quote_item_name.持仓](GZQHStore.StockDetail).source, GZQHStore.StockDetail.f132),
            rizengColor: formatStockColor(single_quote[quote_item_name.持仓](GZQHStore.StockDetail).source - GZQHStore.StockDetail.f132, 0),
            amount: formatBigNumber(data.trends[index].amount, 2),
            jiesuan: formatNumToFixed(single_quote[quote_item_name.结算](GZQHStore.StockDetail).source, GZQHStore.StockDetail.f59),
            zuojie: formatNumToFixed(single_quote[quote_item_name.昨结](GZQHStore.StockDetail).source, GZQHStore.StockDetail.f59),
          }
          GZQHStore.setChartMouseMoveData(FSData)
        }
      } else if (props.pagetype == PageType.期权) {
        FSData = {
          ...FSData,
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
          chicang: formatBigNumber(single_quote[quote_item_name.持仓](OptionStore.StockDetail).source, 2),
        }
        OptionStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.B股) {
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](BStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](BStore.StockDetail).source) * 100, 2) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
        }
        BStore.setChartMouseMoveData(FSData)
      } else if (props.pagetype == PageType.场内基金) {
        FSData = {
          ...FSData,
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
          liangbi: formatNumToFixed(FundStore.StockDetail.f50, FundStore.StockDetail.f152),
        }
        FundStore.setChartMouseMoveData(FSData)
      }  else if (props.pagetype == PageType.全球债券) {
        FSData = {
          ...FSData,
        }
        if((props.stocksubtype == StockSubType.中国关键期国债 || props.stocksubtype == StockSubType.美国关键期国债 || props.stocksubtype == StockSubType.全球关键期国债) && props.reverseColor){
          FSData = {
            ...FSData,
            _color: formatTipsCompareColor(data.trends[index].price,data.prePrice)
          }
        }
        TipsStore.setChartMouseMoveData(FSData)
      } else if(props.pagetype == PageType.未知){
        FSData = {
          ...FSData,
          huanshou: toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](DefaultStore.StockDetail).source) * 100, 2) == "-" ? "-" : toFix((data.trends[index].amount / single_quote[quote_item_name.流通市值](DefaultStore.StockDetail).source) * 100, 2) + "%",
          zongshou: formatBigNumber(data.trends[index].volume, 2),
          amount: formatBigNumber(data.trends[index].amount, 2),
        }
        DefaultStore.setChartMouseMoveData(FSData)
      }
    }
    // 
    if (state == "end") {
      if (props.pagetype == PageType.沪深A股) {
        AStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.英股) {
        UKStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.瑞士GDR) {
        CHStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.美股) {
        USStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.外汇) {
        ForexStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.全球指数) {
        GlobalIndexStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.板块) {
        BKStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.choice指数) {
        ZSStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.人民币中间价) {
        CNYStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.债券) {
        BondStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.港股) {
        HKStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.商品期货) {
        QHStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.国际期货) {
        GlobalFutureStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.金融期货) {
        GZQHStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.期权) {
        OptionStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.B股) {
        BStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.场内基金) {
        FundStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.全球债券) {
        TipsStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.未知) {
        DefaultStore.setChartMouseMoveData(null)
      }
    }
  }

  const getTradeStatus = (data: any) => {
    let tradeStatus = single_quote[quote_item_name.交易状态2](data).source
    if (tradeStatus == 1) {
      fsStatus = 1
    } else if (tradeStatus == 17 || tradeStatus == 18 || tradeStatus == 19) {
      fsStatus = 2
    } else {
      fsStatus = 0
    }
  }

  const RefreshTimeChart = () => {
    if (props.pagetype == PageType.港股) {
      //港股不登陆或者海外不刷新
      hk_rule.isDelayCache().then((back: any) => {
        if (!back.re) {
          timer && clearInterval(timer)
          timer = setInterval(() => {
            if (props.charttype == ChartType.分时 || props.charttype == ChartType.五日) {
              drawTimeChart(props.quotedata.quotecode)
            }
          }, 30 * 1000)
        }
      })
    } else {
      timer && clearInterval(timer)
      timer = setInterval(() => {
        if (props.charttype == ChartType.分时 || props.charttype == ChartType.五日) {
          drawTimeChart(props.quotedata.quotecode)
        }
      }, 30 * 1000)
    }
  }

  useEffect(() => {
    if (props.quotedata.quotecode) {
      // if (typeof window.WeixinJSBridge == "object" && typeof window.WeixinJSBridge.invoke == "function") {
      //   setTimeout(() => {
      //     drawTimeChart(props.quotedata.quotecode,fsStatus)
      //   }, 1100)
      // } else {
      drawTimeChart(props.quotedata.quotecode)
      // }
      RefreshTimeChart()
    }
    return () => {
      timer && clearInterval(timer)
    }
  }, [props.charttype, fsStatus])

  return (
    <Observer>
      {() => (
        <ul className="charts">
          <li className="time-chart">
            <div className="left-p">
              <div id="chart1"></div>
            </div>
            {props.charttype == ChartType.分时 &&
              (props.pagetype == PageType.沪深A股 ||
                props.pagetype == PageType.B股 ||
                props.pagetype == PageType.英股 ||
                props.pagetype == PageType.债券 ||
                props.pagetype == PageType.港股 || props.pagetype == PageType.外汇 || props.pagetype == PageType.场内基金 || props.pagetype == PageType.瑞士GDR || props.stocksubtype == StockSubType.国债个券 || props.stocksubtype == StockSubType.预发行个券) && (
                <div className="right-p">
                  <TimeTrade pagetype={props.pagetype} quotedata={props.quotedata} stocksubtype={props.stocksubtype} bondsubtype={props.bondsubtype} />
                </div>
              )}
          </li>
        </ul>
      )}
    </Observer>
  )
}

let kline: any
// K线图
export function KCharts(props: { quotedata: quotedata; charttype: ChartType; pagetype: PageType; stocksubtype: StockSubType; bondsubtype?: PageBondType; reverseColor?: boolean }) {
  // 绘制K线图
  const drawKChart = (type: ChartType, stockCode: string) => {
    let klt = "101"
    if (type == ChartType.日K) {
      klt = "101"
    } else if (type == ChartType.周K) {
      klt = "102"
    } else if (type == ChartType.月K) {
      klt = "103"
    } else if (type == ChartType["5分钟"]) {
      klt = "5"
    } else if (type == ChartType["15分钟"]) {
      klt = "15"
    } else if (type == ChartType["30分钟"]) {
      klt = "30"
    } else if (type == ChartType["60分钟"]) {
      klt = "60"
    }

    let kConfig = {
      id: "#chart2",
      code: stockCode,
      ut: "f057cbcbce2a86e2866ab8877db1d059",
      beg: "",
      end: "20500000",
      lmt: "66",
      klt: klt,
      fqt: "1",
      cursor: true,
      simplemode: true,
      simpletype: "kline",
      reverseColor: ((props.stocksubtype == StockSubType.中国关键期国债 || props.stocksubtype == StockSubType.美国关键期国债 || props.stocksubtype == StockSubType.全球关键期国债) && props.reverseColor) ? true : false,
      cursorCallback: function (data: any, index: number, state: any, config: any) {
        // data 是数据 ，index是当前数据的位置，state 是滑动状态
        if (props.pagetype == PageType.沪深A股) {
          AStore.setChartType(type)
        } else if (props.pagetype == PageType.英股) {
          UKStore.setChartType(type)
        } else if (props.pagetype == PageType.瑞士GDR) {
          CHStore.setChartType(type)
        } else if (props.pagetype == PageType.美股) {
          USStore.setChartType(type)
        } else if (props.pagetype == PageType.外汇) {
          ForexStore.setChartType(type)
        } else if (props.pagetype == PageType.全球指数) {
          GlobalIndexStore.setChartType(type)
        } else if (props.pagetype == PageType.板块) {
          BKStore.setChartType(type)
        } else if (props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.choice指数) {
          ZSStore.setChartType(type)
        } else if (props.pagetype == PageType.人民币中间价) {
          CNYStore.setChartType(type)
        } else if (props.pagetype == PageType.债券) {
          BondStore.setChartType(type)
        } else if (props.pagetype == PageType.港股) {
          HKStore.setChartType(type)
        } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.商品期货) {
          QHStore.setChartType(type)
        } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.国际期货) {
          GlobalFutureStore.setChartType(type)
        } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.金融期货) {
          GZQHStore.setChartType(type)
        } else if (props.pagetype == PageType.期权) {
          OptionStore.setChartType(type)
        } else if (props.pagetype == PageType.B股) {
          BStore.setChartType(type)
        } else if (props.pagetype == PageType.场内基金) {
          FundStore.setChartType(type)
        } else if (props.pagetype == PageType.全球债券) {
          TipsStore.setChartType(type)
        } else if(props.pagetype == PageType.未知) {
          DefaultStore.setChartType(type)
        }
        showKChartData(data, index, state, klt, config.lmt)
      },
    }
    if (window.mobilequotechart && stockCode) {
      try {
        kline = null
      } catch (error) {}
      kline = new window.mobilequotechart(kConfig)
      kline.init()
    }
  }

  const showKChartData = (data: any, index: number, state: string, type: string, lmt: any) => {
    const ktotal = Number(lmt) - 20
    const trends = data.trends.slice(-ktotal)
    if (state == "start" || state == "move") {
      let KData = {}
      // 当前价、涨跌幅、涨跌额
      const newPrice = trends[index].price
      const zdf = toFix(trends[index].zdf, 2) + "%"
      const zde = trends[index].zde
      const _color = Number(trends[index].zdf) > 0 ? 'red' : ((Number(trends[index].zdf) < 0) ? 'green' : 'gray')
      KData = {
        newPrice,
        zdf,
        zde,
        _color,
      }

      if (props.pagetype == PageType.沪深A股) {
        if (Number(type) > 100) {
          if (Number(type) == 101) {
            KData = {
              ...KData,
              time: trends[index].time,
              phvolume: trends[index].phvolume == "0" ? "-" : trends[index].phvolume,
              phamount: trends[index].phamount == "0" ? "-" : formatBigNumber(trends[index].phamount, 2),
            }
          } else {
            KData = {
              ...KData,
              zongzhi: single_quote[quote_item_name.总市值](AStore.StockDetail).element,
              phvolume: trends[index].phvolume == "0" ? "-" : trends[index].phvolume,
              phamount: trends[index].phamount == "0" ? "-" : formatBigNumber(trends[index].phamount, 2),
            }
          }
        } else {
          KData = {
            ...KData,
            zongzhi: single_quote[quote_item_name.总市值](AStore.StockDetail).element,
            liuzhi: single_quote[quote_item_name.流通市值](AStore.StockDetail).element,
            shiying: single_quote[quote_item_name.市盈率](AStore.StockDetail).element,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
        }
        AStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.英股) {
        // 今开、最高、最低、换手、总手、金额、总值、市盈、市净率
        if (Number(type) == 101) {
          KData = {
            ...KData,
            time: trends[index].time,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
        }
        UKStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.瑞士GDR) {
        if (Number(type) == 101) {
          KData = {
            ...KData,
            time: trends[index].time,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
        }
        CHStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.美股) {
        if (Number(type) == 101) {
          KData = {
            ...KData,
            time: trends[index].time,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          zongzhi: single_quote[quote_item_name.总市值](USStore.StockDetail).element,
        }
        USStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.外汇) {
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          zuoshou: trends[index].zs,
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          amplitude: formatBigNumber(trends[index].amplitude, 2,"%"),
        }
        ForexStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.全球指数) {
        if (Number(type) == 101) {
          KData = {
            ...KData,
            time: trends[index].time,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
          amplitude: formatBigNumber(trends[index].amplitude, 2,"%"),
        }
        GlobalIndexStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.板块) {
        if (Number(type) == 101) {
          KData = {
            ...KData,
            time: trends[index].time,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
        }
        BKStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.choice指数) {
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
          zongzhi: single_quote[quote_item_name.总市值](AStore.StockDetail).element,
          liuzhi: single_quote[quote_item_name.流通市值](AStore.StockDetail).element,
          shiying: single_quote[quote_item_name.市盈率](AStore.StockDetail).element,
        }
        ZSStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.人民币中间价) {
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          zuoshou: trends[index].zs,
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
          amplitude: formatBigNumber(trends[index].amplitude, 2,"%"),
        }
        CNYStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.债券) {
        if (props.bondsubtype == PageBondType.上证可转债 || props.bondsubtype == PageBondType.深证可转债) {
          KData = {
            ...KData,
            jinkai: trends[index].openprice,
            jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
            maxPrice: trends[index].maxprice,
            maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
            minPrice: trends[index].minprice,
            minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
            huanshou: formatUnit(trends[index].hs, "%"),
            zongshou: formatBigNumber(trends[index].volume, 2),
            amount: trends[index].amount,
            liangbi: formatNumToFixed(BondStore.StockDetail.f50, BondStore.StockDetail.f152),
          }
          BondStore.setChartMouseMoveData(KData)
        } else if (props.bondsubtype == PageBondType.上证质押式回购 || props.bondsubtype == PageBondType.深证质押式回购) {
          KData = {
            ...KData,
            jinkai: trends[index].openprice,
            jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
            maxPrice: trends[index].maxprice,
            maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
            minPrice: trends[index].minprice,
            minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
            newPrice: trends[index].price,
            _color: formatBondSingleColor(trends[index].zdf),
            zdf: toFix(trends[index].zdf, 2, "%"),
            zde: trends[index].zde,
            amount: trends[index].amount,
            volume: trends[index].volume,
          }
          BondStore.setChartMouseMoveData(KData)
        } else if (props.bondsubtype == PageBondType.上证现券 || props.bondsubtype == PageBondType.深证现券 || props.bondsubtype == PageBondType.北证债券) {
          KData = {
            ...KData,
            newPrice: trends[index].price,
            _color: formatBondSingleColor(trends[index].zdf),
            zdf: toFix(trends[index].zdf, 2, "%"),
            zde: trends[index].zde,
            volume: trends[index].volume,
            amount: trends[index].amount,
          }
          BondStore.setChartMouseMoveData(KData)
        }
      } else if (props.pagetype == PageType.港股) {
        if (Number(type) == 101) {
          KData = {
            ...KData,
            time: trends[index].time,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
        }
        HKStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.期货) {
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
        }
        if (props.stocksubtype == StockSubType.商品期货) {
          KData = {
            ...KData,
            zongshou: formatBigNumber(trends[index].volume, 2),
            chicang: formatBigNumber(single_quote[quote_item_name.持仓](QHStore.StockDetail).source, 2),
            rizeng: formatToSub(single_quote[quote_item_name.持仓](QHStore.StockDetail).source, QHStore.StockDetail.f132),
            rizengColor: formatStockColor(single_quote[quote_item_name.持仓](QHStore.StockDetail).source - QHStore.StockDetail.f132, 0),
            jiesuan: formatNumToFixed(single_quote[quote_item_name.结算](QHStore.StockDetail).source, QHStore.StockDetail.f59),
            zuojie: formatNumToFixed(single_quote[quote_item_name.昨结](QHStore.StockDetail).source, QHStore.StockDetail.f59),
          }
          QHStore.setChartMouseMoveData(KData)
        } else if (props.stocksubtype == StockSubType.国际期货) {
          KData = {
            ...KData,
            zongshou: formatBigNumber(trends[index].volume, 2),
            chicang: formatBigNumber(single_quote[quote_item_name.持仓](GlobalFutureStore.StockDetail).source, 2),
            rizeng: formatToSub(single_quote[quote_item_name.持仓](GlobalFutureStore.StockDetail).source, GlobalFutureStore.StockDetail.f132),
            rizengColor: formatStockColor(single_quote[quote_item_name.持仓](GlobalFutureStore.StockDetail).source - GlobalFutureStore.StockDetail.f132, 0),
            jiesuan: formatNumToFixed(single_quote[quote_item_name.结算](GlobalFutureStore.StockDetail).source, GlobalFutureStore.StockDetail.f59),
            zuojie: formatNumToFixed(single_quote[quote_item_name.昨结](GlobalFutureStore.StockDetail).source, GlobalFutureStore.StockDetail.f59),
          }
          GlobalFutureStore.setChartMouseMoveData(KData)
        } else if (props.stocksubtype == StockSubType.金融期货) {
          KData = {
            ...KData,
            zongshou: formatBigNumber(trends[index].volume, 2),
            chicang: formatBigNumber(single_quote[quote_item_name.持仓](GZQHStore.StockDetail).source, 2),
            rizeng: formatToSub(single_quote[quote_item_name.持仓](GZQHStore.StockDetail).source, GZQHStore.StockDetail.f132),
            rizengColor: formatStockColor(single_quote[quote_item_name.持仓](GZQHStore.StockDetail).source - GZQHStore.StockDetail.f132, 0),
            amount: formatBigNumber(trends[index].amount, 2),
            jiesuan: formatNumToFixed(single_quote[quote_item_name.结算](GZQHStore.StockDetail).source, GZQHStore.StockDetail.f59),
            zuojie: formatNumToFixed(single_quote[quote_item_name.昨结](GZQHStore.StockDetail).source, GZQHStore.StockDetail.f59),
          }
          GZQHStore.setChartMouseMoveData(KData)
        }
      } else if (props.pagetype == PageType.期权) {
        if (Number(type) == 101) {
          KData = {
            ...KData,
            time: trends[index].time,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
          liangbi: formatNumToFixed(OptionStore.StockDetail.f50, OptionStore.StockDetail.f152),
          chicang: formatBigNumber(single_quote[quote_item_name.持仓](OptionStore.StockDetail).source, 2),
        }
        OptionStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.B股) {
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
        }
        BStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.场内基金) {
        if (Number(type) == 101) {
          KData = {
            ...KData,
            time: trends[index].time,
          }
        }
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
          liangbi: formatNumToFixed(FundStore.StockDetail.f50, FundStore.StockDetail.f152),
        }
        FundStore.setChartMouseMoveData(KData)
      } else if (props.pagetype == PageType.全球债券) {
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatTipsCompareColor(trends[index].openprice, trends[index].zs),
          zuoshou: trends[index].zs,
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatTipsCompareColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatTipsCompareColor(trends[index].minprice, trends[index].zs),

        }
        if(((props.stocksubtype == StockSubType.中国关键期国债 || props.stocksubtype == StockSubType.美国关键期国债 || props.stocksubtype == StockSubType.全球关键期国债) && props.reverseColor)){
          KData = {
            ...KData,
            _color:Number(trends[index].zdf) > 0 ? 'green' : ((Number(trends[index].zdf) < 0) ? 'red' : 'gray'),
          }
        }
        TipsStore.setChartMouseMoveData(KData)
      } else if(props.pagetype == PageType.未知){
        KData = {
          ...KData,
          jinkai: trends[index].openprice,
          jkColor: formatStockColor(trends[index].openprice, trends[index].zs),
          maxPrice: trends[index].maxprice,
          maxPriceColor: formatStockColor(trends[index].maxprice, trends[index].zs),
          minPrice: trends[index].minprice,
          minPriceColor: formatStockColor(trends[index].minprice, trends[index].zs),
          huanshou: formatUnit(trends[index].hs, "%"),
          zongshou: formatBigNumber(trends[index].volume, 2),
          amount: formatBigNumber(trends[index].amount, 2),
        }
        DefaultStore.setChartMouseMoveData(KData)
      }
    }

    if (state == "end") {
      if (props.pagetype == PageType.沪深A股) {
        AStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.英股) {
        UKStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.瑞士GDR) {
        CHStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.美股) {
        USStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.外汇) {
        ForexStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.全球指数) {
        GlobalIndexStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.板块) {
        BKStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.沪深京指数 || props.pagetype == PageType.choice指数) {
        ZSStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.人民币中间价) {
        CNYStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.债券) {
        BondStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.港股) {
        HKStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.商品期货) {
        QHStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.国际期货) {
        GlobalFutureStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.金融期货) {
        GZQHStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.期权) {
        OptionStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.B股) {
        BStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.场内基金) {
        FundStore.setChartMouseMoveData(null)
      } else if (props.pagetype == PageType.全球债券) {
        TipsStore.setChartMouseMoveData(null)
      } else if(props.pagetype == PageType.未知){
        DefaultStore.setChartMouseMoveData(null)
      }
    }
  }

  useEffect(() => {
    if (props.quotedata.quotecode) {
      drawKChart(props.charttype, props.quotedata.quotecode)
    }
  }, [props.charttype])

  return (
    <>
      <ul className="charts">
        <li className="k-chart">
          <div id="chart2" className="right-chart"></div>
        </li>
      </ul>
    </>
  )
}
